import * as React from 'react';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={704.25}
      height={129.87}
      viewBox="0 0 186.333 34.361"
      {...props}
    >
      <defs>
        <symbol overflow="visible" id="prefix__a">
          <path d="M3.156-21.922c0 12.719 9.89 22.547 22.86 22.547 8.89 0 13.672-3.969 15.375-5.61.75-.687 1.328-1.687 1.328-2.827 0-1.891-1.39-3.282-3.344-3.282-1.016 0-1.89.516-2.578 1.078C35.03-8.437 32-6.046 26.14-6.046c-8.938 0-15.75-6.938-15.75-16 0-9.079 6.812-16 15.75-16 5.734 0 8.89 2.452 10.265 3.515.703.515 1.516.89 2.469.89 1.828 0 3.328-1.39 3.328-3.343 0-1.313-.687-2.453-1.953-3.328-2.016-1.516-6.547-4.422-13.984-4.422-12.97 0-23.11 10.078-23.11 22.812zm0 0" />
        </symbol>
        <symbol overflow="visible" id="prefix__b">
          <path d="M5.672-3.656C5.672-1.516 7.188 0 9.328 0h25.703c1.828 0 3.078-1.328 3.078-3.219 0-1.828-1.25-3.078-3.078-3.078h-22.11v-13.61h18.454c1.766 0 2.953-1.202 2.953-2.968s-1.187-2.953-2.953-2.953H12.922v-11.969H34.39c1.828 0 3.093-1.328 3.093-3.219 0-1.828-1.265-3.078-3.093-3.078H9.328c-2.14 0-3.656 1.5-3.656 3.578zm0 0" />
        </symbol>
        <symbol overflow="visible" id="prefix__c">
          <path d="M5.672-3.281c0 2.14 1.453 3.594 3.594 3.594 2.078 0 3.515-1.454 3.515-3.594v-30.11L35.594-2.14C36.609-.687 38.047.313 39.75.313c2.516 0 4.344-1.891 4.344-4.47v-36.796c0-2.016-1.438-3.469-3.516-3.469-2.078 0-3.531 1.453-3.531 3.469v29.547l-22.438-30.61c-1-1.515-2.515-2.406-4.156-2.406-2.765 0-4.781 1.953-4.781 4.797zm0 0" />
        </symbol>
        <symbol overflow="visible" id="prefix__d">
          <path d="M32.953-44.094H3.97c-1.89 0-3.156 1.25-3.156 3.078 0 1.891 1.265 3.22 3.156 3.22h10.844v34.452c0 2.14 1.5 3.656 3.64 3.656 2.078 0 3.594-1.515 3.594-3.656v-34.453h10.906c1.828 0 3.14-1.328 3.14-3.219 0-1.828-1.312-3.078-3.14-3.078zm0 0" />
        </symbol>
        <symbol overflow="visible" id="prefix__e">
          <path d="M9.328.313c2.078 0 3.594-1.516 3.594-3.657V-16.25h9.25L33.266-1.266c.687.954 1.703 1.579 2.953 1.579 2.015 0 3.406-1.454 3.406-3.47 0-.937-.438-1.89-1.063-2.702l-8.578-11.532C36.031-19.03 40-23.938 40-30.297c0-8.062-6.172-13.797-15.297-13.797H9.328c-2.14 0-3.656 1.5-3.656 3.578v37.172c0 2.14 1.516 3.656 3.656 3.656zm3.594-22.235v-16.062h10.89c5.547 0 8.954 3.39 8.954 8.062 0 4.594-3.407 8-8.953 8zm0 0" />
        </symbol>
        <symbol overflow="visible" id="prefix__f">
          <path d="M5.672-3.656C5.672-1.516 7.188 0 9.328 0h23.688c1.89 0 3.203-1.328 3.203-3.281 0-1.89-1.313-3.203-3.203-3.203H12.922v-34.344c0-2.078-1.516-3.594-3.594-3.594-2.14 0-3.656 1.516-3.656 3.594zm0 0" />
        </symbol>
        <symbol overflow="visible" id="prefix__g">
          <path d="M9.766-44.422c-2.204 0-3.782 1.516-3.782 3.656v37.36c0 2.203 1.579 3.719 3.782 3.719 2.14 0 3.718-1.516 3.718-3.72v-37.359c0-2.14-1.578-3.656-3.718-3.656zm0 0" />
        </symbol>
      </defs>
      <path
        d="M5.997 1.764a4.234 4.234 0 00-4.233 4.233v22.367a4.234 4.234 0 004.233 4.233h174.339a4.234 4.234 0 004.233-4.233V5.997a4.234 4.234 0 00-4.233-4.233zm0 0"
        fill="none"
        stroke="#fff"
        strokeWidth={3.528}
      />
      <use
        xlinkHref="#prefix__a"
        x={159.431}
        y={258.302}
        width="100%"
        height="100%"
        transform="matrix(.35278 0 0 .35278 -48.511 -66.04)"
        fill="#fff"
      />
      <use
        xlinkHref="#prefix__b"
        x={212.854}
        y={258.302}
        width="100%"
        height="100%"
        transform="matrix(.35278 0 0 .35278 -48.511 -66.04)"
        fill="#fff"
      />
      <use
        xlinkHref="#prefix__c"
        x={262.624}
        y={258.302}
        width="100%"
        height="100%"
        transform="matrix(.35278 0 0 .35278 -48.511 -66.04)"
        fill="#fff"
      />
      <use
        xlinkHref="#prefix__d"
        x={321.214}
        y={258.302}
        width="100%"
        height="100%"
        transform="matrix(.35278 0 0 .35278 -48.511 -66.04)"
        fill="#fff"
      />
      <use
        xlinkHref="#prefix__b"
        x={366.888}
        y={258.302}
        width="100%"
        height="100%"
        transform="matrix(.35278 0 0 .35278 -48.511 -66.04)"
        fill="#fff"
      />
      <use
        xlinkHref="#prefix__e"
        x={416.658}
        y={258.302}
        width="100%"
        height="100%"
        transform="matrix(.35278 0 0 .35278 -48.511 -66.04)"
        fill="#fff"
      />
      <use
        xlinkHref="#prefix__f"
        x={468.884}
        y={258.302}
        width="100%"
        height="100%"
        transform="matrix(.35278 0 0 .35278 -48.511 -66.04)"
        fill="#fff"
      />
      <use
        xlinkHref="#prefix__g"
        x={514.748}
        y={258.302}
        width="100%"
        height="100%"
        transform="matrix(.35278 0 0 .35278 -48.511 -66.04)"
        fill="#fff"
      />
      <use
        xlinkHref="#prefix__c"
        x={543.035}
        y={258.302}
        width="100%"
        height="100%"
        transform="matrix(.35278 0 0 .35278 -48.511 -66.04)"
        fill="#fff"
      />
      <use
        xlinkHref="#prefix__b"
        x={601.624}
        y={258.302}
        width="100%"
        height="100%"
        transform="matrix(.35278 0 0 .35278 -48.511 -66.04)"
        fill="#fff"
      />
      <path
        d="M8.843 17.354c0 4.487 3.488 7.952 8.064 7.952 3.131 0 4.82-1.4 5.419-1.977.267-.244.467-.6.467-1 0-.666-.49-1.154-1.177-1.154-.356 0-.667.176-.911.376-.623.555-1.688 1.4-3.754 1.4-3.154 0-5.553-2.443-5.553-5.641 0-3.2 2.399-5.644 5.553-5.644 2.02 0 3.131.867 3.62 1.245.244.178.534.311.866.311.645 0 1.178-.489 1.178-1.177 0-.467-.244-.866-.689-1.178-.711-.533-2.31-1.554-4.93-1.554-4.576 0-8.153 3.554-8.153 8.04zm19.735 6.44c0 .756.533 1.29 1.288 1.29h9.064c.643 0 1.088-.467 1.088-1.134 0-.643-.445-1.088-1.088-1.088h-7.797v-4.797h6.508c.622 0 1.045-.423 1.045-1.045 0-.621-.423-1.044-1.045-1.044h-6.508v-4.22h7.573c.645 0 1.089-.467 1.089-1.133 0-.645-.444-1.088-1.089-1.088h-8.84c-.755 0-1.288.533-1.288 1.266zm17.557.134c0 .755.512 1.267 1.267 1.267.733 0 1.244-.512 1.244-1.267V13.31l8.041 11.018c.356.511.867.867 1.466.867.888 0 1.533-.666 1.533-1.578V10.645c0-.71-.512-1.222-1.245-1.222-.732 0-1.243.511-1.243 1.222v10.418L49.29 10.268c-.356-.534-.888-.845-1.467-.845-.977 0-1.688.689-1.688 1.688zM76.423 9.535H66.205c-.665 0-1.11.443-1.11 1.088 0 .666.445 1.133 1.11 1.133h3.821v12.15c0 .755.534 1.289 1.289 1.289.733 0 1.266-.534 1.266-1.289v-12.15h3.842c.644 0 1.111-.467 1.111-1.133 0-.645-.467-1.088-1.11-1.088zm6.495 14.26c0 .755.533 1.288 1.288 1.288h9.062c.645 0 1.089-.466 1.089-1.133 0-.643-.444-1.088-1.089-1.088h-7.795v-4.797h6.507c.623 0 1.044-.423 1.044-1.045 0-.621-.421-1.044-1.044-1.044h-6.507v-4.22h7.574c.644 0 1.088-.467 1.088-1.133 0-.645-.444-1.088-1.088-1.088h-8.84c-.756 0-1.29.533-1.29 1.266zm18.846 1.4c.733 0 1.266-.534 1.266-1.289v-4.553h3.265l3.91 5.286c.245.334.6.556 1.044.556.711 0 1.199-.512 1.199-1.223 0-.332-.156-.665-.378-.955l-3.02-4.063c2.133-.58 3.532-2.311 3.532-4.555 0-2.843-2.176-4.864-5.398-4.864h-5.42c-.755 0-1.288.533-1.288 1.266v13.105c0 .755.533 1.289 1.288 1.289zm1.266-7.841V11.69h3.842c1.956 0 3.155 1.199 3.155 2.843 0 1.622-1.2 2.82-3.155 2.82zm15.87 6.44c0 .756.533 1.29 1.288 1.29h8.353c.665 0 1.132-.467 1.132-1.156 0-.665-.467-1.132-1.132-1.132h-7.086V10.689c0-.731-.534-1.266-1.267-1.266-.755 0-1.288.535-1.288 1.266zm17.624-14.371c-.778 0-1.333.535-1.333 1.288v13.173c0 .777.555 1.31 1.333 1.31.755 0 1.31-.533 1.31-1.31V10.711c0-.753-.555-1.288-1.31-1.288zm8.535 14.505c0 .755.511 1.267 1.265 1.267.735 0 1.245-.512 1.245-1.267V13.31l8.04 11.018c.356.511.867.867 1.467.867.889 0 1.532-.666 1.532-1.578V10.645c0-.71-.511-1.222-1.243-1.222-.733 0-1.244.511-1.244 1.222v10.418l-7.907-10.795c-.356-.534-.89-.845-1.467-.845-.978 0-1.688.689-1.688 1.688zm20.668-.133c0 .755.533 1.288 1.288 1.288h9.064c.645 0 1.088-.466 1.088-1.133 0-.643-.443-1.088-1.088-1.088h-7.797v-4.797h6.508c.622 0 1.045-.423 1.045-1.045 0-.621-.423-1.044-1.045-1.044h-6.508v-4.22h7.575c.644 0 1.089-.467 1.089-1.133 0-.645-.445-1.088-1.089-1.088h-8.842c-.755 0-1.288.533-1.288 1.266zm0 0"
        fill="none"
        stroke="#fff"
        strokeWidth={0.353}
      />
    </svg>
  );
}

export default SvgComponent;
